import { useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { useShippingSpecialRateDeleteMutation } from 'api';
import { notification } from 'components';
import { ErrorMappingValueType } from 'typings';

export const useDeleteModal = (onDeleteModalClose: () => void) => {
  const [notificationApi, contextHolder] = notification.useNotification();
  const { id } = useParams();
  const [shippingSpecialRateDelete, { isLoading }] = useShippingSpecialRateDeleteMutation();

  const openNotificationWithIcon = useCallback(
    (messageContent: ErrorMappingValueType) => {
      const { type, message } = messageContent;
      notificationApi[type]({ message: message });
    },
    [notificationApi]
  );

  const onRemoveConfirm = useCallback(
    async (shipping: { id: string | undefined }) => {
      try {
        const { data, error }: any = await shippingSpecialRateDelete({
          id: shipping.id,
          brandId: id,
        });

        if (data?.success) {
          onDeleteModalClose();
          openNotificationWithIcon({
            type: 'success',
            message: `The Special Shipping Rate was successfully deleted.`,
          });
        } else if (error?.data?.success === false) {
          const { data = {} } = error.data;
          Object.keys(data).forEach((_key: string) => {
            openNotificationWithIcon({
              type: 'error',
              message: data[_key],
            });
          });
        } else {
          openNotificationWithIcon({
            type: 'error',
            message: error?.data?.error || 'Something went wrong!',
          });
        }
      } catch (err) {
        console.error('Error deleting sales manager:', err);
        openNotificationWithIcon({
          type: 'error',
          message: 'An unexpected error occurred!',
        });
      }
    },
    [shippingSpecialRateDelete, openNotificationWithIcon, onDeleteModalClose, id]
  );

  return {
    onRemoveConfirm,
    contextHolder,
    isLoading,
  };
};
